var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ backgroundImage: 'url(' + _vm.src + ')' }),on:{"mouseenter":_vm.handleIn,"mouseleave":_vm.handleOut}},[_c('div',{ref:"shade",staticClass:"mask",on:{"click":_vm.clickMask}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-578532ee","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/maskSolt.vue
// module id = 1422
// module chunks = 0